import { appRouterPaths } from 'services/navigation';
import { ProductionCalendarPage } from 'pages/ProductionCalendar';
import type { AppRouteProps } from '../types';

export const productionCalendarPageRoute: AppRouteProps = {
  path: appRouterPaths.productionCalendar,
  element: <ProductionCalendarPage />,
};
